import React from 'react';
import { Link } from 'react-router-dom';
import { Button, IconButton, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faHome,
    faInfoCircle,
    faListUl,
    faPenFancy,
    faPhoneVolume,
    faKey
} from '@fortawesome/free-solid-svg-icons';

import { NavbarProps } from './AdminNavbar';
import { Theme } from '../../config';

export const NavbarLinks: React.FC<NavbarProps> = React.memo(
    ({
        landing,
        about,
        services,
        blog,
        contact,
        login,
        reset,
        drawer,
        lightYellow
    }) => (
        <>
            <Link to='/'>
                <Button
                    fullWidth={drawer}
                    size={drawer ? 'large' : 'medium'}
                    onClick={reset}
                    variant='text'
                    className={drawer ? 'navbar__link--drawer' : 'navbar__link'}
                    sx={{ color: landing ? Theme.primary : '#111' }}
                    startIcon={<FontAwesomeIcon size='sm' icon={faHome} />}
                >
                    Home
                </Button>
            </Link>
            <Link to='/about'>
                <Button
                    fullWidth={drawer}
                    size={drawer ? 'large' : 'medium'}
                    onClick={reset}
                    variant='text'
                    className={drawer ? 'navbar__link--drawer' : 'navbar__link'}
                    sx={{ color: about ? Theme.primary : '#111' }}
                    startIcon={
                        <FontAwesomeIcon size='sm' icon={faInfoCircle} />
                    }
                >
                    About
                </Button>
            </Link>
            <Link to='/services'>
                <Button
                    fullWidth={drawer}
                    size={drawer ? 'large' : 'medium'}
                    onClick={reset}
                    variant='text'
                    className={drawer ? 'navbar__link--drawer' : 'navbar__link'}
                    sx={{ color: services ? Theme.primary : '#111' }}
                    startIcon={<FontAwesomeIcon size='sm' icon={faListUl} />}
                >
                    Services
                </Button>
            </Link>
            <a href='https://prispek.co.za/prispek-blogs'>
                <Button
                    fullWidth={drawer}
                    size={drawer ? 'large' : 'medium'}
                    onClick={reset}
                    variant='text'
                    className={drawer ? 'navbar__link--drawer' : 'navbar__link'}
                    sx={{ color: blog ? Theme.primary : '#111' }}
                    startIcon={<FontAwesomeIcon size='sm' icon={faPenFancy} />}
                >
                    Blogs
                </Button>
            </a>
            <Link to='/contact'>
                <Button
                    fullWidth={drawer}
                    size={drawer ? 'large' : 'medium'}
                    variant='contained'
                    onClick={reset}
                    className={drawer ? 'navbar__link--drawer' : 'navbar__link'}
                    color='primary'
                    startIcon={
                        <FontAwesomeIcon size='sm' icon={faPhoneVolume} />
                    }
                >
                    Book
                </Button>
            </Link>
            <Tooltip title='Staff Login' arrow>
                <Link to='/login'>
                    {drawer ? (
                        <Button
                            fullWidth={drawer}
                            size={drawer ? 'large' : 'medium'}
                            variant='contained'
                            onClick={reset}
                            className='navbar__link--drawer'
                            color={login ? 'primary' : 'secondary'}
                            startIcon={
                                <FontAwesomeIcon size='sm' icon={faKey} />
                            }
                        >
                            Login
                        </Button>
                    ) : (
                        <IconButton
                            className='navbar__link'
                            // size='medium'
                            style={{
                                background: lightYellow,
                                color: 'black',
                                opacity: login ? 0.5 : 1
                            }}
                        >
                            <FontAwesomeIcon size='xs' icon={faKey} />
                        </IconButton>
                    )}
                </Link>
            </Tooltip>
        </>
    )
);
